const TOUR_STORAGE_KEY = "legion.evWorkstationTour.completed.v1";

export function getEvWorkstationTourCompleted(): boolean {
  try {
    return window.localStorage.getItem(TOUR_STORAGE_KEY) === "true";
  } catch {
    return false;
  }
}

export function setEvWorkstationTourCompleted(completed: boolean): void {
  try {
    if (completed) {
      window.localStorage.setItem(TOUR_STORAGE_KEY, "true");
    } else {
      window.localStorage.removeItem(TOUR_STORAGE_KEY);
    }
  } catch {
    // localStorage can fail in private/restricted contexts; guide still works.
  }
}
